const getDBDateTimeNow = () => {
	const d = new Date(Date.now());
	const mes = d.getMonth() + 1;
	const date_s = [
		d.getFullYear().toString(),
		mes < 10 ? `0${mes}` : `${mes}`,
		d.getDate() < 10 ? `0${d.getDate()}` : `${d.getDate()}`
	].join("-");

	const time_s = [
		d.getHours() < 10 ? `0${d.getHours()}` : `${d.getHours()}`,
		d.getMinutes() < 10 ? `0${d.getMinutes()}` : `${d.getMinutes()}`,
		d.getSeconds() < 10 ? `0${d.getSeconds()}` : `${d.getSeconds()}`
	].join(":");

	const res = `${date_s} ${time_s}`;

	return res;
};

export default getDBDateTimeNow;